import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Pagination } from "antd";

import {
  SearchAction,
  InterestAction,
  PhotoreqAction,
} from "../../store/actions";

import Cardloader from "../../components/loader/cardloader";
import Spacer from "../../components/spacer/spacer";
import DashboardCard from "../../components/dashboardcard/dashboardcard";
import CardBottomButton from "../../components/dashboardcard/cardbottombutton";
import { VioletButton, PrimaryButton } from "../../components/button";
import images from "../../assets";

import "./styles.css";

const RecommendedMatches = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.profile);
  const { interestsAll } = useSelector((state) => state.interests);
  const { photoreqAll } = useSelector((state) => state.photoreq);
  const { recommendedMatches, isRecommendedLoading } = useSelector(
    (state) => state.search,
  );

  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(8);

  useEffect(() => {
    if (profileData?.username) {
      const payload = {
        username: profileData?.username,
      };
      dispatch(SearchAction.recommendedSearch(payload));
    }
  }, [profileData]);

  useEffect(() => {
    const totalPages =
      Math.ceil((recommendedMatches?.length || 0) / pageSize) || 1;
    if (pageNo > totalPages) {
      setPageNo(totalPages);
    }
  }, [pageNo, pageSize, recommendedMatches]);

  const pagedMatches = useMemo(() => {
    const list = recommendedMatches || [];
    const startIndex = (pageNo - 1) * pageSize;
    return list.slice(startIndex, startIndex + pageSize);
  }, [pageNo, pageSize, recommendedMatches]);

  const handlePageChange = (pageNumber) => {
    setPageNo(pageNumber);
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };

  const handleSendInterest = (id) => {
    dispatch(InterestAction.sendInterest({ receiverId: id }));
  };

  const handleSendPhotoReq = (id) => {
    dispatch(PhotoreqAction.sendPhotoreq({ receiverId: id }));
  };

  return (
    <div>
      <div className="recommended-container">
        <div className="header-container">
          <h1 className="section-heading">Recommended Matches</h1>
          <VioletButton
            onClick={() => navigate("/match-preference")}
            text="Improve Match"
          />
        </div>

        {isRecommendedLoading ? (
          <Cardloader />
        ) : recommendedMatches?.length > 0 ? (
          <div className="recommended-matches-container">
            {pagedMatches.map((item, index) => {
              const interestSent = interestsAll?.some(
                (profile) => profile.receiverId === item?.username,
              );

              const photoreqSent = photoreqAll?.some(
                (profile) => profile.receiverId === item?.username,
              );
              return (
                <DashboardCard
                  item={item}
                  index={index}
                  key={index}
                  redirectedfrom="recommendedSearch"
                >
                  <CardBottomButton
                    icon={images.cardMessage}
                    onClick={() =>
                      navigate(
                        `/messages?username=${item?.username}&firstName=${item?.firstName}&lastName=${item?.lastName}&photo=${item?.profilePicture}`,
                      )
                    }
                    title="Send Message"
                  />
                  <CardBottomButton
                    icon={images.cardPhotoReq}
                    onClick={() => handleSendPhotoReq(item?.username)}
                    title="Send Photo Request"
                    disabled={photoreqSent ? true : false}
                  />
                  <CardBottomButton
                    icon={images.cardmatch}
                    onClick={() => handleSendInterest(item?.username)}
                    title="Send Interest"
                    disabled={interestSent ? true : false}
                  />
                </DashboardCard>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-col justify-center items-center p-10 w-full gap-4">
            <img
              src={images.noSearchIcon}
              alt="no notifications"
              className="h-[160px] lg:h-full"
            />
            <div className="text-basePrimary font-bold text-[24px] lg:text-[32px]">
              No Matches Yet
            </div>
            <p className="text-[14px] text-center max-w-[500px]">
              We’re still searching for the right matches for you. To help us
              recommend better profiles, please update your profile and match
              preferences.
            </p>
            <PrimaryButton
              text={"Update My Preferences"}
              style={{ width: "250px" }}
              onClick={() => navigate("/match-preference")}
            />
          </div>
        )}

        <Spacer height="36px" />
        <div className="flex justify-center items-center">
          <Pagination
            current={pageNo}
            total={recommendedMatches?.length || 0}
            pageSize={pageSize}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
        <Spacer height="12px" />
      </div>
    </div>
  );
};

export default RecommendedMatches;
